'use strict';

import jsonPageData from './json-page-data';
import Events from 'events/events';
import DomUtils from '../helpers/dom-utils';

let pageData = jsonPageData.getData();

let servicesSelector = '.additional-service-options input[type="checkbox"]';
let checkedServicesSelector = '.additional-service-options input[type="checkbox"]:checked';
let exclusionsSelector = '.additional-service-options-item__extra';

function addServicesListeners(){
  let servicesCheckBoxes = document.querySelectorAll(servicesSelector);
  for(let item of servicesCheckBoxes)
    item.addEventListener('change', recalculate);
}

function recalculate(e){

  pageData = jsonPageData.refetchData();

  let checkedSelectedServices = document.querySelectorAll(checkedServicesSelector);

  if(e) {
    const targetEl = e.target;
    if(targetEl) {
      const targetData = targetEl.dataset;
      if(targetData) {
        const dialogueId = targetData.dialogueTarget;
        if(dialogueId) {
          const dialogue = document.querySelector(`[data-dialogue="${dialogueId}"]`);
          let exclusions =  document.querySelectorAll(exclusionsSelector);
          if(e.target.checked) {
            DomUtils.removeClass(dialogue, 'u-hidden');
            if(exclusions.length > 0) {
              DomUtils.addClass(exclusions[0], 'u-hidden');
            }
          } else {
            DomUtils.addClass(dialogue, 'u-hidden');
            if(exclusions.length > 0) {
              DomUtils.removeClass(exclusions[0], 'u-hidden');
            }
          }
        }
      }
    }
  }

  if(checkedSelectedServices.length > 0){
    const currentTotalPrice = getCurrentTotalPrice(checkedSelectedServices, pageData)

    Events.pdpAdditionalPriceAdded.trigger(formatPrice(currentTotalPrice), true);

    updateSubtotalOnPage(checkedSelectedServices, currentTotalPrice)
  } else {
    Events.pdpAdditionalPriceAdded.trigger(formatPrice(Number(pageData.totalPrice)), false);
  }
  toggleSubtotalLabel(checkedSelectedServices);
}

function updateSubtotalOnPage(selectedServices, subtotal){
  let price_tag = document.querySelector('.add-to-basket-item-details .price-included-additional-services');
  price_tag.childNodes[0].nodeValue = formatPrice(subtotal);
}

function formatPrice(price){
  return "£" + price.toFixed(2);
}

function toggleSubtotalLabel(selectedServices){
  let price = document.querySelector('.add-to-basket-item-details .price:not(.price-included-additional-services)');
  let priceIncludeAdditionalServices = document.querySelector('.add-to-basket-item-details .price-included-additional-services');
  if( price && selectedServices.length > 0 ){
    price.classList.add('u-hidden');
    if (priceIncludeAdditionalServices) {
      priceIncludeAdditionalServices.classList.remove('u-hidden');
    }
  } else if ( price ){
    price.classList.remove('u-hidden');
    if (priceIncludeAdditionalServices) {
      priceIncludeAdditionalServices.classList.add('u-hidden');
    }

  }
}

function getCurrentTotalPrice(selectedServices, data){
  let subtotal = Number(data.totalPrice);
  let optionalServices = data['optionalServices'];
  for(let index = 0; index < selectedServices.length; index++) {
    let serviceId = selectedServices[index].getAttribute('value');
    let serviceObj = optionalServices[serviceId];
    if(serviceObj){
      subtotal+=Number(serviceObj['price']);
    }
  }
  return subtotal
}

function isRecalculationNeeded(){
  return document.querySelectorAll(servicesSelector).length;
}

export default {
  init : function(){
    if(isRecalculationNeeded()){
      recalculate();
      addServicesListeners();
    }
  }
}
